import TabEmpty from 'components/molecules/TabEmpty';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import './styles.scss';

const translationsManager = {
  TITLE: '_COMMON_AREA_EMPTY_TITLE',
  TEXT: '_COMMON_AREA_EMPTY_TEXT',
  LINK_TEXT: '_COMMON_AREA_ADD_SPACE',
};

interface CommonAreaContentEmptyTemplateProps {
  onVisibleCreate: () => void;
}

const CommonAreaContentEmptyTemplate: FC<CommonAreaContentEmptyTemplateProps> = ({ onVisibleCreate }) => {
  const { t } = useTranslation();

  return (
    <div className={'CommonAreaContentEmptyTemplate__container'}>
      <div className={'CommonAreaContentEmptyTemplate__empty'}>
        <TabEmpty
          title={t(translationsManager.TITLE)}
          text={t(translationsManager.TEXT)}
          linkText={t(translationsManager.LINK_TEXT)}
          onClick={onVisibleCreate}
        />
      </div>
    </div>
  );
};

export default CommonAreaContentEmptyTemplate;
